<template>
  <form v-if="!this.chatExpired"
    novalidate="novalidate"
    class="mm-form form-chatbox-input"
    action="">

    <fieldset class="mm-form-fieldset">
      <div class="mm-form-input">
        <input type="text"
          class="chatbox-input"
          id="chatbox-input"
          :value="this.message"
          autocomplete="off"
          placeholder="Start typing"
          v-on:keyup.enter="submitMessage()"
          @input="updateValue"
          :disabled="isInputTextDisabled"/>

        <div class="input-action-container">
          <span class="char-limit" :class="{'limit-reached': message.length === this.$chatInputCharLimit}">{{ message.length }}/{{ this.$chatInputCharLimit }}</span>
          <button type="button" class="mm-button send-message-btn" @click="submitMessage()">
            <div class="icon-black">
              <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'><path stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M22 2L13.5 10.5M22 2L15 21L11 13L3 9L22 2Z'/></svg>
            </div>
            <div class="icon-gray">
              <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'><path stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='0.3' stroke-width='1.5' d='M22 2L13.5 10.5M22 2L15 21L11 13L3 9L22 2Z'/></svg>
            </div>
            <div class="icon-gray2">
              <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'><path stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='0.4' stroke-width='1.5' d='M22 2L13.5 10.5M22 2L15 21L11 13L3 9L22 2Z'/></svg>
            </div>
            <div class="icon-gray3">
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M22 2L13.5 10.5M22 2L15 21L11 13L3 9L22 2Z' stroke='white' stroke-width='1.125' stroke-linecap='round' stroke-linejoin='round'/></svg>
            </div>
          </button>
        </div>
      </div>
    </fieldset>
  </form>

  <div class="start-again-container w-100 text-center">
    <button type="button" class="mm-button" :class="{'expired-restart': this.chatExpired}" @click="startAgain()" :disabled="this.totalMessages === 1 || (isInputTextDisabled && !this.chatExpired)"> {{ this.$translations.buttons.startagain }}</button>
  </div>

  <div class="form-chatbox-input">
    <div class="disclaimer mt-1">
      {{this.$translations.label.disclaimer.firstpart}} <a :href="this.$urls.termsUrl" target="_blank" class="link">{{this.$translations.label.disclaimer.terms}}</a> {{this.$translations.label.disclaimer.secondpart}} <a :href="this.$urls.privacyUrl" target="_blank" class="link">{{this.$translations.label.disclaimer.privacypolicy}}</a>.
    </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        message: '',
      }
    },
    props: [
      'disableTextInput',
      'totalMessages',
      'chatExpired'
    ],
    emits: ['send', 'restartChat'],
    methods: {
      submitMessage() {
        if (this.message !== '') {
          this.$emit('send', this.message);
          this.message = '';
        }
      },
      startAgain() {
        this.$emit('restartChat');
      },
      addMultiEventListener(element, eventNames, listener) {
        var events = eventNames.split(' ');
        for (var i=0; i < events.length; i++) {
          element.addEventListener(events[i], listener, false);
        }
      },
      updateValue(event) {
        const value = event.target.value
        if (String(value).length <= this.$chatInputCharLimit) {
          this.message = value;
        }
        this.$forceUpdate();
      }
    },
    computed: {
      isInputTextDisabled() {
        return this.disableTextInput;
      }
    },
    mounted() {
      const chatInput = document.getElementById('chatbox-input');
      if(chatInput) {
        this.addMultiEventListener(chatInput, 'click tap',() => {
          chatInput.focus();
        });

        chatInput.addEventListener('blur', () => {
          window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
          });
        });
      }
    }
}
</script>
